import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sub-detail',
  templateUrl: './sub-detail.component.html',
  styleUrls: ['./sub-detail.component.scss']
})
export class SubDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
